// Import Packages
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Import Material UI Elements
import Button from '@material-ui/core/Button';

// Import Components
import AssignModal from './components/AssignModal/AssignModal';
import ConfigureModal from './components/ConfigureModal/ConfigureModal';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      Abdullah Onur Yeşil
 */
function AdvancedAssign({ action, showAlert, variables, setOpenVariable, recorder, variableRender }) {
    const { t } = useTranslation();
    const [showAssignModal, setShowAssignModal] = useState(false);
    const [indexValue, setIndexValue] = useState({});
    const [showIndexInput, setShowIndexInput] = useState(false);
    const [selectedVariable, setSelectedVariable] = useState({});
    const [assignValues, setAssignValues] = useState([]);
    const [configureModal, setConfigureModal] = useState({ isOpen: false, index: 0 });

    const label = 'CONTENT.CONFIGURATION-FORM.ADVANCED-ACTIONS.ADVANCED-ASSIGN.';

    // When the configure button in the configuration form is pressed, the registered data is assigned
    const openAssignModal = () => {
        setShowAssignModal(true)
        if (!action.fields.assigns) {
            action.fields.assigns = { type: 'multipleAssign', value: [] }
        } else if (action.fields.assigns && action.fields.assigns.value) {
            try {
                const assigns = action.fields.assigns.value;
                setAssignValues(assigns);
            } catch (error) {
            }
        }
        if (!action.fields.source_value || action.fields.source_value?.value === '') {
            action.fields.source_value = { value: '' }
            setSelectedVariable('');
        } else if (action.fields.source_value && action.fields.source_value.value) {
            const sv = variables.find(x => x.name === action.fields.source_value.value);
            setSelectedVariable(sv);
        }
    }

    // Called from jsonViewer component
    const handleVariableChange = (event) => {
        let updatedData = event.target.value;
        updatedData = updatedData === "" ? {} : updatedData;
        setSelectedVariable(updatedData);
        if (event.target.value.type === 'array') {
            setShowIndexInput(true);
        } else {
            setShowIndexInput(false);
        }
    }

    const handleIndexChange = (event) => {
        if (event.target.value >= 0) {
            setIndexValue(event.target.value);
        }
    }

    // Used to save manipulations.
    const saveConfiguration = (actions, index) => {
        let av = [...assignValues]

        av[index].manipulations = JSON.parse(JSON.stringify(actions));
        setAssignValues(av)
        setConfigureModal({ isOpen: false, index: 0 })
    }
    // Used to save all configurations made
    const saveAssign = () => {
        action.fields.assigns.value = assignValues;
        action.fields.source_value.value = selectedVariable.name;
        setShowAssignModal(false);
    }

    return (
        <div>
            <div className="form-element">
                <Button onClick={openAssignModal} style={{
                    background: "#031226",
                    borderRadius: "2px",
                    color: "#fff",
                    fontSize: "12px",
                    fontWeight: 700,
                    textTransform: "none"
                }}>
                    {t(label + 'CONFIGURE')}
                </Button>
            </div>
            {
                showAssignModal && !configureModal.isOpen ? (
                    <AssignModal variables={variables} setOpenVariable={setOpenVariable}
                        showAssignModal={showAssignModal}
                        setShowAssignModal={setShowAssignModal} onVariableChange={handleVariableChange}
                        onVariableIndexChange={handleIndexChange} setShowIndexInput={setShowIndexInput}
                        indexValue={indexValue} selectedVariable={selectedVariable}
                        showIndexInput={showIndexInput} assignValues={assignValues}
                        setAssignValues={setAssignValues} setConfigureModal={setConfigureModal}
                        saveAssign={saveAssign} />
                ) : configureModal.isOpen && (
                    <ConfigureModal selectedVariable={selectedVariable} saveConfiguration={saveConfiguration}
                        configureModal={configureModal} setConfigureModal={setConfigureModal}
                        variables={variables} setOpenVariable={setOpenVariable}
                        value={assignValues[configureModal.index]} variableRender={variableRender} />
                )
            }
        </div>
    );
}

export default AdvancedAssign;
